module.exports = __webpack_public_path__ + "static/media/space-alert.51d68278.svg";